module.exports = __webpack_public_path__ + "img/logo-white.46dc7908.svg";